export const TEST_ID = 'homeIcon';
